<template>
    <div class="rows overflow-wrapper" style="position: relative;">
        <div v-if="item.idNadrazenePodani !== -1" class="bubble">
            Toto je dodatečné podání ({{ item.n }} z {{ item.q }}) k&nbsp;nadřazenému podání {{ item.dossNP }} ze&nbsp;dne {{ formatDate(item.odeslanoNP) }}
        </div>

        <div class="overflow-container">
            <div class="cols" style="gap: 10px;">
                <button v-if="item.idNadrazenePodani === -1" @click="goBack">Zpět</button>
                <button v-if="!isManager && !isInvestor && item.stavZakazky == 0" @click="edit">Editace</button>
                <button v-if="!isManager && !isInvestor && item.idNadrazenePodani === -1 && item.stavZakazky == 0" @click="dodatecnePodani">Dodatečné podání</button>
            </div>
            <div style="margin-top: 10px;">
                <table class="table-border-none">
                    <tr>
                        <td style="padding-left: 0;">Zakázka:</td>
                        <td>{{ item.zakazka }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Instituce:</td>
                        <td>{{ item.instituce }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Pracoviště:</td>
                        <td>{{ item.pracoviste }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" style="padding-left: 0;">Kontaktní osoba DOSS:</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 30px;">Pracovník:</td>
                        <td>{{ item.dossKontaktPracovnik }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 30px;">Telefon:</td>
                        <td>{{ item.dossKontaktTelefon }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 30px;">E-mail:</td>
                        <td>{{ item.dossKontaktEmail }}</td>
                    </tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr>
                        <td style="padding-left: 0;">Předmět:</td>
                        <td>{{ item.predmet }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Druh podání - žádost o:</td>
                        <td>{{ item.druhPodani }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Odpovědná osoba:</td>
                        <td>{{ item.odpovednaOsoba }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Odesláno:</td>
                        <td>{{ formatDate(item.datumOdeslani) }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Předpokládaná lhůta k vyřízení:</td>
                        <td>{{ formatDate(item.predpokLhuta) }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Lhůta k vyřízení:</td>
                        <td>{{ formatDate(item.lhutaKVyrizeni) }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Číslo jednací podání:</td>
                        <td>{{ item.cisloJednaci }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Příloha podání:</td>
                        <td><span v-html="prilohaPodani"></span></td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0; vertical-align: top;">Dokumentace:</td>
                        <td>
                            <div v-for="(o, i) in item.odkazy" :key="i"><a :href="o">{{ o }}</a></div>
                            <div v-for="(s, i) in item.soubory.filter(a => a.typ === 2)" :key="i"><span v-html="priloha(s.id)"></span></div>
                        </td>
                    </tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr>
                        <td style="padding-left: 0;">Stanovisko vydáno:</td>
                        <td>{{ formatDate(item.datumVydaniStanoviska) }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Přijetí stanoviska:</td>
                        <td>{{ formatDate(item.datumPrijetiStanoviska) }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Číslo jednací odesílatele:</td>
                        <td>{{ item.cisloJednaciVydani }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Druh stanoviska:</td>
                        <td>{{ item.druhStanoviska }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Platnost stanoviska:</td>
                        <td>{{ !item.platnostNeomezene ? formatDate(item.platnostStanoviska) : "Neomezeně" }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0;">Přílohy stanoviska:</td>
                        <!-- <td><span v-html="prilohaStanoviska"></span></td> -->
                        <td>
                            <div v-for="(s, i) in item.soubory.filter(a => a.typ === 1)" :key="i"><span v-html="stanovisko(s.id)"></span></div>
                        </td>
                    </tr>
                    <tr><td colspan="2">&nbsp;</td></tr>
                    <tr>
                        <td style="padding-left: 0;">Stav:</td>
                        <td>{{ item.status }}</td>
                    </tr>
                    <tr>
                        <td style="padding-left: 0; vertical-align: top;">Poznámka:</td>
                        <td><span v-html="replaceLineEnd(item.poznamka)"></span></td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import dayjs from 'dayjs'

    export default {
        name: 'ShowPodani',
        props: ['isManager', 'isInvestor', 'idPodani'],
        data() {
            return {
                item: {
                    'id': -1,
                    'idZakazka': -1,
                    'idNadrazenePodani': -1,
                    'iddoss': -1,
                    'iddossPrac': -1,
                    'dossKontaktEmail': '',
                    'dossKontaktPracovnik': '',
                    'dossKontaktTelefon': '',
                    'poradiPodani': 0,
                    'poradiPodaniInstituce': 0,
                    'predmet': '',
                    'idDruhPodani': -1,
                    'idOdpovednaOsoba': -1,
                    'datumOdeslani': null,
                    'predpokLhuta': null,
                    'lhutaKVyrizeni': null,
                    'cisloJednaci': '',
                    'datumVydaniStanoviska': null,
                    'datumPrijetiStanoviska': null,
                    'cisloJednaciVydani': '',
                    'idDruhStanoviska': -1,
                    'platnostStanoviska': null,
                    'idStatus': -1,
                    'odkazy': [],
                    'soubory': [],
                    'zakazka': '',
                    'instituce': '',
                    'pracoviste': '',
                    'druhPodani': '',
                    'odpovednaOsoba': '',
                    'druhStanoviska': '',
                    'status': '',
                    'gRepre': '',
                    'cislo': '',
                    'platnostNeomezene': false,
                    'poznamka': '',
                    'n': 0,
                    'q': 0,
                    'dossNP': '',
                    'odeslanoNP': null
                }
            }
        },
        computed: {
            prilohaPodani() {
                let index = this.item.soubory.findIndex(s => s.typ === 0)
                return index !== -1 ? '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>' : ''
            },
            // prilohaStanoviska() {
            //     let index = this.item.soubory.findIndex(s => s.typ === 1)
            //     return index !== -1 ? '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>' : ''
            // }
        },
        methods: {
            goBack() {
                this.$emit('hidePodani')
            },
            load() {
                this.$progress.start()
                api.getPodaniById(this.idPodani)
                .then(response => {
                    this.item = response.data
                })
                .catch(error => {
                    console.log('Error: ', error)
                })
                this.$progress.finish()
            },
            edit() {
                this.$emit('editPodani', this.item.id)
            },
            dodatecnePodani() {
                this.$emit('gotoNewPodani', this.item.idZakazka, this.item.id)
            },
            formatDate(date) {
                return date !== null ? dayjs(date).format('D.M.YYYY') : ''
            },
            replaceLineEnd(text) {
                return text.replace('\n', '<br />')
            },
            priloha(id) {
                let index = this.item.soubory.findIndex(s => s.id === id)
                return index !== -1 ? '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>' : ''
            },
            stanovisko(id) {
                let index = this.item.soubory.findIndex(s => s.id === id)
                return index !== -1 ? '<a target="_blank" href="' + process.env.VUE_APP_API_URL + '/Podani/download?id=' + this.item.soubory[index].id + '">' + this.item.soubory[index].nazev + '</a>' : ''
            }
        },
        created() {
            this.load()
        }
    }
</script>